"use client";

import ErrorMessage from "@/components/ErrorMessage";

export default function NotFound() {
    return (
        <ErrorMessage
            message={["הדף שחיפשת לא נמצא"]}
            buttonLabel="לדף הבית"
            onButtonClick={() => (window.location.href = "/")}
        />
    );
}
